import './CustomerHealth.css';
import { Outlet, useNavigate } from 'react-router-dom';

/**
 * Customer Health — layout route. A thin shell: sticky topbar + the active child route
 * (portfolio index or brand detail) via <Outlet>. Each child fetches its own scoped data;
 * there is no shared portfolio state here.
 */
function CustomerHealth() {
  const navigate = useNavigate();

  return (
    <div className="ch-root">
      <header className="ch-topbar">
        <div className="ch-brandline" onClick={() => navigate('/dashboard/customer-health')}>
          <span className="ch-mark">GK</span>
          <span className="ch-suite">Gatekeeper Intelligence Suite</span>
          <span className="ch-pill">CUSTOMER HEALTH</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 13, color: '#666' }}>Customer Success · Portfolio</span>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: '#0b2e9a', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600 }}>CS</div>
        </div>
      </header>

      <Outlet />
    </div>
  );
}

export default CustomerHealth;
